import React, { Fragment } from 'react'

import { Badge, Discount, Divider } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import PropTypes from 'prop-types'

import i18n from 'Pods/Shared/I18n'
import SvgNavbarIcon from 'Pods/UnifiedNavigation/Shared/NavbarIcon/NavbarIcon'

import MenuItem from './Components/MenuItem/MenuItem'
import UserGdprMessage from './Components/UserGdprMessage/UserGdprMessage'

function LegacyUserInfoMenu({ userData, locale, handleLogout, newRoyaltyUi = false }) {
  const attributes = userData?.attributes || {}
  const userGdprSelection = attributes.gdprConsent
  const isAdmin = attributes.adminDashboard?.url?.length > 0
  const subscriptionMenuEnabled = attributes.subscriptionMenuEnabled

  function doLogout(e) {
    e.preventDefault()
    handleLogout()
  }

  return (
    <div className="popover-content nav-options-dropdown">
      {userGdprSelection === 'undecided' && <UserGdprMessage />}
      <div className="nav-options-dropdown__section">
        {!newRoyaltyUi && (
          <Fragment>
            <MenuItem title="Dashboard" url="/profile" icon={['dashboard']} dataName="My Dashboard" />
            <Divider customClass="cgt-mt-10 cgt-mb-10" />
          </Fragment>
        )}

        <a
          href="/profile/upload/model"
          /* eslint-disable-next-line max-len */
          className="cgt-menu-item cgt-menu-item--medium undecorated-text user-menu-item js-track-link-click cgt-menu-item--icon-left temp"
          data-keyword="Upload 3D Model"
          data-track-text={i18n.t('navigation.user_menu.seller.publishing', {
            ns: 'rails',
            lng: locale,
          })}
          data-track-label="Profile"
        >
          <span className="cgt-menu-item__lead-icon">
            <div className="cgt-icon cgt-icon__icon cgt-icon--small cgt-icon--not-spaced cgt-icon--light">
              <SvgNavbarIcon type="upload" size="small" className="wayfinder__action-icon-svg" />
            </div>
          </span>
          <span className="cgt-menu-item__text">
            {i18n.t('navigation.user_menu.seller.publishing', {
              ns: 'rails',
              lng: locale,
            })}
          </span>
        </a>

        <MenuItem
          title={i18n.t('navigation.user_menu.seller.models', {
            ns: 'rails',
            lng: locale,
          })}
          url="/profile/models"
          icon={['details']}
          dataName="My 3D Models"
        />
        <MenuItem
          title={i18n.t('navigation.user_menu.seller.sales', {
            ns: 'rails',
            lng: locale,
          })}
          url="/profile/sales"
          icon={['wallet']}
          dataName="Sales"
        />
        <Divider customClass="cgt-mt-10 cgt-mb-10" />
        {subscriptionMenuEnabled && (
          <Fragment>
            <MenuItem
              title={i18n.t('navigation.user_menu.seller.subscription', {
                ns: 'rails',
                lng: locale,
              })}
              url="/profile/subscription"
              svgComponent={Discount}
              dataName="Subscription"
            >
              <Badge className="community-dropdown__badge community-dropdown__badge--success">
                NEW
              </Badge>
            </MenuItem>
            <Divider customClass="cgt-mt-10 cgt-mb-10" />
          </Fragment>
        )}

        <MenuItem
          title={i18n.t('navigation.user_menu.buyer.purchases', {
            ns: 'rails',
            lng: locale,
          })}
          url="/profile/purchases"
          icon={['inbox']}
          dataName="Purchases"
        />
        <MenuItem
          title={i18n.t('navigation.user_menu.buyer.wishlist', {
            ns: 'rails',
            lng: locale,
          })}
          url="/3d-models?licenses%5B%5D=wish_list_only"
          icon={['bookmark']}
          dataName="Wish List"
        />
        <Divider customClass="cgt-mt-10 cgt-mb-10" />

        <div className="user-menu__info-link">
          <MenuItem
            title={i18n.t('navigation.user_menu.seller.freelance', {
              ns: 'rails',
              lng: locale,
            })}
            url="/profile/projects"
            icon={['folder-person']}
            dataName="3D Jobs Applications"
          />
        </div>
        <MenuItem
          title={i18n.t('navigation.user_menu.seller.publish_project', {
            ns: 'rails',
            lng: locale,
          })}
          url="/3d-modeling-jobs/new"
          icon={['folder-add']}
          dataName="Post a project"
        />
        <MenuItem
          title={i18n.t('navigation.user_menu.seller.find_new_projects', {
            ns: 'rails',
            lng: locale,
          })}
          url="/3d-modeling-jobs/browse"
          icon={['format-list-bullets']}
          dataName="Browse freelance jobs"
        />
        <Divider customClass="cgt-mt-10 cgt-mb-10" />

        {isAdmin && (
          <MenuItem
            title={i18n.t('navigation.user_menu.dashboard', {
              ns: 'rails',
              lng: locale,
            })}
            url={userData.attributes.adminDashboard.url}
            dataName="Admin"
          />
        )}

        {attributes?.username && (
          <div className="user-settings-row__link">
            <MenuItem
              title={i18n.t('navigation.user_menu.public_profile', {
                ns: 'rails',
                lng: locale,
              })}
              url={`/${attributes.username}`}
              icon={['portrait']}
              dataName="Public Profile"
            />
          </div>
        )}

        <MenuItem
          title={i18n.t('navigation.user_menu.settings', {
            ns: 'rails',
            lng: locale,
          })}
          url="/profile/settings"
          icon={['settings']}
          dataName="Account Settings"
        />

        <MenuItem
          title={i18n.t('navigation.user_menu.logout', {
            ns: 'rails',
            lng: locale,
          })}
          url="/users/logout"
          icon={['logout']}
          dataName="Log out"
          dataMethod="delete"
          onClick={doLogout}
        />
      </div>
    </div>
  )
}

LegacyUserInfoMenu.propTypes = {
  userData: PropTypes.shape({
    attributes: PropTypes.shape({
      gdprConsent: PropTypes.string,
      adminDashboard: PropTypes.shape({
        url: PropTypes.string,
      }),
      username: PropTypes.string,
      subscriptionMenuEnabled: PropTypes.bool,
    }),
  }).isRequired,
  locale: PropTypes.string.isRequired,
  handleLogout: PropTypes.func.isRequired,
  newRoyaltyUi: PropTypes.bool,
}

export default LegacyUserInfoMenu
